import { Spinner } from '@nextui-org/react';

// Carga de una sección o página completa. Para botones usa isLoading y para
// tablas largas Skeleton. Ver design.md › Estados.
const LoadingState = ({ label }: { label?: string }) => (
  <div className='flex justify-center py-10'>
    <Spinner label={label} />
  </div>
);

export default LoadingState;
